import './vaccinate-section.scss';

export default () => {
	let calText = $( '.js-datepicker-text' ).html();

	$( window ).load( function () {
		function showCalendarText () {
			$( '.ui-datepicker-calendar' ).after( calText );
		}

		window.setTimeout( showCalendarText, 500 );
	} );

	$( window ).on( 'resize load', function () {
		let windowWidth = $( window ).width();
		let calHolder = $( '.js-datepicker' );
		let windowWidthMobile = $( window ).width();

		if ( windowWidth >= 1024 ) {
			calHolder.datepicker( {
				numberOfMonths: 3,
				dayNamesMin: [
					'zo',
					'ma',
					'di',
					'wo',
					'do',
					'vr',
					'za',
				],
				monthNames: [
					'Januari',
					'Februari',
					'Maart',
					'April',
					'Mei',
					'Juni',
					'Juli',
					'Augustus',
					'September',
					'Oktober',
					'November',
					'December',
				],
			} );
		}

		if ( windowWidthMobile <= 1024 ) {
			calHolder.datepicker( {
				numberOfMonths: 1,
				dayNamesMin: [
					'zo',
					'ma',
					'di',
					'wo',
					'do',
					'vr',
					'za',
				],
				monthNames: [
					'Januari',
					'Februari',
					'Maart',
					'April',
					'Mei',
					'Juni',
					'Juli',
					'Augustus',
					'September',
					'Oktober',
					'November',
					'December',
				],
			} );
		}
	} );
};
